<template>
  <b-card class="shadow-sm quick-access">
    <b-card-title class="mb-2 ml-2 mt-1" style="font-size: 13px;">
      <b-icon icon="cursor-fill" variant="primary" class="mr-1" />
      Atalhos
    </b-card-title>
    <b-card-body>
      <div
        v-if="userAccessStore.access.nfe"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'nfeNova' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">NFe</span>
      </div>
      <div
        v-if="userAccessStore.access.vendas"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'vendasNovo' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">NFCe</span>
      </div>
      <div
        v-if="userAccessStore.access.orcamento"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'orcamentoNovo' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">Orçamentos</span>
      </div>
      <div
        v-if="userAccessStore.access.pedidos"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'pedidosNovo' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">Pedidos</span>
      </div>
      <div
        v-if="userAccessStore.access.nfse"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'nova-nfseServicos' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">NFSe</span>
      </div>
      <div
        v-if="userAccessStore.access.ordensServicos"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'ordensServicosNova' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">OS</span>
      </div>
      <div
        v-if="userAccessStore.access.prospect"
        class="bg-secondary rounded gutter-b p-2"
        style="cursor: pointer; font-size: 12px;"
        @click="$router.push({ name: 'linkProspect' })"
      >
        <ArrowRight class="svg-icon mr-1" :size="16" />
        <span class="font-weight-bold">Atendimento</span>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";
import { userAccessStore } from "@/userAccessStore";
import ArrowRight from "vue-material-design-icons/ArrowRight";

export default {
  mixins: [SistemaMixin],
  components: {
    ArrowRight,
  },
  data() {
    return {
      userAccessStore,
    };
  },
};
</script>

<style>
.quick-access {
  background-color: color-mix(in srgb, var(--primary-color) 12%, #ffffff);
}
.quick-access .card-body {
  padding: 10px 10px 0 10px;
}
</style>
